




























import { Component, Vue } from 'vue-property-decorator';

import ProgressBar from '@/components/ProgressBar.vue';

import { SystemModule } from '@/store/modules/system/system.store';
import { SystemMetrics } from '@/types/apiServerContract';

@Component({
    components: {
        ProgressBar
    }
})
export default class ServerStatus extends Vue {
	interval: any = 0;

	get Metrics(): SystemMetrics | null {
	    return SystemModule.metrics;
	}

	get Disks(): any[] {
	    const disks: any[] = [];
	    if (!this.Metrics) return disks;

	    for (const [key, value] of Object.entries(this.Metrics.disks)) {
	        disks.push({
	            name: key,
	            pct: value.usedPct
	        });
	    }

	    return disks;
	}

	async GetSystemMetrics() {
	    await SystemModule.GetSystemMetrics();
	}

	created() {
	    this.GetSystemMetrics();

	    this.interval = setInterval(() => this.GetSystemMetrics(), 60000);
	}

	destroyed() {
	    clearInterval(this.interval);
	}
}
